import { FaSpinner } from 'react-icons/fa'

export function Spinner() {
  return (
    <div className='flex justify-center items-center'>
      <FaSpinner className='animate-spin w-12 h-12' role='status'></FaSpinner>
    </div>
  )
}
